import React from 'react';
import BackDrop from '../Backdrop/Backdrop';
import styles from './Spinner.scss';

const Spinner = () => (
  <div>
    <BackDrop show={true} />
    <div className={styles['lds-spinner']}>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);

export default Spinner;
